import { render, staticRenderFns } from "./UserDetailsSettings.vue?vue&type=template&id=45638f7e&scoped=true"
import script from "./UserDetailsSettings.vue?vue&type=script&lang=js"
export * from "./UserDetailsSettings.vue?vue&type=script&lang=js"
import style0 from "./UserDetailsSettings.vue?vue&type=style&index=0&id=45638f7e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45638f7e",
  null
  
)

export default component.exports